PortalMap.prototype.lookup = function (address, latlng) {
  var self = this;
  if(address === undefined  || address === true || address === false) {
    if(this.lookupform === true || !this.lookupform) {
        var init = false;
        this.lookupform = $(self.mapSelector).parent().find('form.map-lookup').on('submit', function() { self.lookup(this.address.value) });
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.lookupform[0]);
    }
    if(address) this.lookupform.css('opacity', '1');
    return;
  }
  var key = makeKey(address);
  if(!key) return self.defaultView();
    function callback(results, status) {
      if(status=='OK' || status=='CACHED') {
        var result = results[0], variables = { name: "" };
        if(!self.lookup.cache[key]) self.lookup.cache[key] = results;
        variables.latlng = result.geometry && result.geometry.location ||null;
        variables.bounds = result.geometry ? result.geometry.bounds || result.geometry.viewport : null;
        variables.type = result.types[0]||'';
        if(result.address_components)
          for(var i = 0; i < result.address_components.length; i++) {
            var r = result.address_components[i], t = r.types[0].replace(/^sublocality_.*/ ,'sublocality');
            var v = r.long_name == r.short_name ? r.long_name : new AddressComponent(r);
            if(!variables[t]) variables[t] = v;
            if(r.types[0]==variables.type) variables.name = r.long_name;
          }
        variables.formatted_address = result.formatted_address;
        variables.key = makeKey(variables.name);
        if(variables.key && !self.lookup.cache[variables.key]) self.lookup.cache[variables.key] = results;

        if(variables.country.toString('short')!='BE') return self.defaultView();
        if(variables.locality) {
          self.map.setZoom(11);
          if(latlng) variables.latlng = latlng;
          self.map.panTo(variables.latlng);
          return;
        }
        self.map.setZoom(8);
        if(variables.latlng) self.map.panTo(variables.latlng);
        else self.map.panToBounds(variables.bounds);
      }
      else
        self.defaultView();
    }
    function AddressComponent(ac) {
      this.short_name = ac.short_name;
      this.long_name = ac.long_name;
    }
    AddressComponent.prototype.toString = function(type) {
      if(type && type.toString().match(/short/)) return this.short_name;
      return this.long_name;
    };

  if(!self.lookup.cache) self.lookup.cache = {};
  if(self.lookup.cache[key]) return callback(self.lookup.cache[key], 'CACHED');
  if(!self.geocoder) self.geocoder = new google.maps.Geocoder(self.map);
  self.geocoder.geocode({ address: address, region: 'BE' }, callback);
  
  function makeKey(text) {
    return stripAccent((text||'')+'').toLowerCase().replace(/[\-\W]+/g, ' ').replace(/^ /, "").replace(/ $/, "");

    function stripAccent(str) {
     var rExps=[
     {re:/[\xC0-\xC6]/g, ch:'A'}, {re:/[\xE0-\xE6]/g, ch:'a'},
     {re:/[\xC8-\xCB]/g, ch:'E'}, {re:/[\xE8-\xEB]/g, ch:'e'},
     {re:/[\xCC-\xCF]/g, ch:'I'}, {re:/[\xEC-\xEF]/g, ch:'i'},
     {re:/[\xD2-\xD6]/g, ch:'O'}, {re:/[\xF2-\xF6]/g, ch:'o'},
     {re:/[\xD9-\xDC]/g, ch:'U'}, {re:/[\xF9-\xFC]/g, ch:'u'},
     {re:/[\xD1]/g, ch:'N'}, {re:/[\xF1]/g, ch:'n'} ];

     for(var i=0, len=rExps.length; i<len; i++)
      str=str.replace(rExps[i].re, rExps[i].ch);
     return str;
    }
  }
}
